import axiosInstance from "./axiosInstance";
import { showAlertError, showAlertExito } from '../utils/alertHelper';

const ventaGeneral = 'ventaGeneral';

// listando ventas para cocina
export const listVentasGeneral = async () => {
    try {
        const response = await axiosInstance.get(`/${ventaGeneral}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// crear venta cocina
export const createVentaGeneral = async (data) => {
    try {
        const response = await axiosInstance.post(`/${ventaGeneral}/create`, data);
        showAlertExito("¡Éxito!", "Venta creada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// actualizar venta cocina
export const updateventaGeneral = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${ventaGeneral}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Venta actualizada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};



/*******************  tipos de formas de venta */
// listando tipos de formas de venta
export const listTiposVenta = async () => {
    try {
        const response = await axiosInstance.get(`/${ventaGeneral}/tipos/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// crear venta cocina
export const createVentaTipo = async (data) => {
    try {
        const response = await axiosInstance.post(`/${ventaGeneral}/tipos/create`, data);
        showAlertExito("¡Éxito!", "Venta creada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};


// actualizar venta cocina
export const updateVentaTipo = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${ventaGeneral}/tipos/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Venta actualizada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};